export default "__VITE_ASSET__BAe0$fcX__"